export const ALL_FIELDS_ROUTE = "/all-fields";
export const ALL_FIELDS_MAP_VIEW_ROUTE = "/all-fields/map-view";
export const ALL_FIELDS_TABLE_VIEW_ROUTE = "/all-fields/table-view";
export const HISTORICAL_DATA_ROUTE = "/historical-data";
export const WALLET_ROUTE = "/wallet";
export const FOOTPRINTING_ROUTE = "/footprinting";

// Anonymous SoilSight funnel. The splat is load-bearing: one route serves the bare landing and every
// step sub-path, so the landing never unmounts when a step opens above it. A sibling `/soilsight/:step`
// would make them alternatives rather than one match.
export const SOILSIGHT_ROUTE = "/soilsight";
export const SOILSIGHT_ROUTE_PATTERN = `${SOILSIGHT_ROUTE}/*`;
export const SOILSIGHT_STEPS = ["location", "rotation", "forecast", "signup"] as const;
export type SoilSightStep = (typeof SOILSIGHT_STEPS)[number];
export const SOILSIGHT_STEP_ROUTE = (step: SoilSightStep) => `${SOILSIGHT_ROUTE}/${step}`;

// We stamp this on funnel signups and read it back at confirm, to land them in SoilSight.
export const SOILSIGHT_SIGNUP_ORIGIN = "soilsight_acquisition";
